import React from 'react';
import { css } from 'styled-components';

//compoenents
import SiimpleMenu from 'src/components/common/modules/global-header/simple-menu/simple-menu';
import Layout from 'src/components/common/theme/Layout';
import SubLevelMenuMobile from './sub-level-menu-mobile';

//helpers
import { checkValue } from 'src/components/functions';
import { getStore } from 'src/utils/store-utils';
import { getMenuItems } from './helpers';

// Css Style Import
import(
  /* webpackChunkName: "sub-level-menu-styles" */ 'src/components/common/modules/global-header/sub-level-menu/styles/sub-level-menu.css'
);

const SubLevelMenu = (props: any) => {
  const storeData = getStore();

  const { partnerHeaderSubNavigation } = storeData;

  const moduleCss = () => {};

  if (!checkValue(partnerHeaderSubNavigation, true)) {
    return null;
  }

  return (
    <Layout
      HtmlTag="div"
      className={`partner-header-sub-level-menu ${props?.loadMenus ? `load-menus` : ''}`}
      css={css`
        ${moduleCss()}
      `}
    >
      <div className="partner-header-sub-level-menu-desktop">
        {partnerHeaderSubNavigation.map((subNavItem) => (
          <SiimpleMenu
            key={subNavItem?.uniquekey}
            menuProps={{
              autoPosition: true,
              subHeaderMenuText: subNavItem?.Title,
              menuItems: getMenuItems(subNavItem?.navigationItems),
            }}
            loadMenus={props?.loadMenus}
          />
        ))}
      </div>
      <SubLevelMenuMobile />
    </Layout>
  );
};

export default SubLevelMenu;
